// Astrea Ops - read every row of a list, not just the first 1000 (v7.77, 16 Oct 2026).
//
// Supabase answers any single read with at most 1000 rows (the project's API "Max rows"
// setting) and says nothing when it stops there. Martin, 16 Oct 2026: AGU26 showed two tasks
// out of 33. The app read all task rows for every project in one request, ordered by position,
// so once the database held more than 1000 tasks only the first one or two of each group came
// back. Every list the app loads whole now reads page by page until a page comes back short.
//
// buildQuery must return a fresh query each time, with an order that is unique (end it with
// the table's key, e.g. .order('id')), so no row is skipped or repeated between pages.
// PAGE must not be more than the Max rows setting (1000, the Supabase default).
export const PAGE = 1000;

export async function selectAll(buildQuery, pageSize = PAGE) {
  const out = [];
  for (let from = 0; ; from += pageSize) {
    const { data, error } = await buildQuery().range(from, from + pageSize - 1);
    if (error) throw error;
    out.push(...(data || []));
    if (!data || data.length < pageSize) break;
  }
  return out;
}

// Same, in the {data, error} shape of a single Supabase read, for code that destructures it.
export async function selectAllRes(buildQuery, pageSize = PAGE) {
  try { return { data: await selectAll(buildQuery, pageSize), error: null }; }
  catch (error) { return { data: null, error }; }
}
